"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_012_USER_PREFS = void 0;
const MIGRATION_012_SQL = `\
CREATE TABLE IF NOT EXISTS omni_user_prefs (
  tenant_id        TEXT NOT NULL,
  user_id          TEXT NOT NULL,
  qa_bootstrapped  BOOLEAN NOT NULL DEFAULT FALSE,
  PRIMARY KEY (tenant_id, user_id)
);
`;
exports.MIGRATION_012_USER_PREFS = {
    id: '012_user_prefs',
    version: 12,
    name: 'user preferences (qa_bootstrapped flag)',
    side: 'server',
    sql: MIGRATION_012_SQL,
};
//# sourceMappingURL=012_user_prefs.js.map